var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83271 14.1493C2.60171 15.799 1.28617 18.0264 1.28617 20.4289C1.28617 22.8314 2.60171 25.0588 4.83271 26.7085C7.06356 28.3581 10.176 29.3977 13.6419 29.3977C17.1079 29.3977 20.2203 28.3581 22.4512 26.7085C24.6822 25.0588 25.9977 22.8314 25.9977 20.4289C25.9977 18.0264 24.6822 15.799 22.4512 14.1493C20.2203 12.4997 17.1079 11.46 13.6419 11.46C10.176 11.46 7.06356 12.4997 4.83271 14.1493ZM4.06801 13.1151C6.54183 11.2859 9.92883 10.1738 13.6419 10.1738C17.3551 10.1738 20.7421 11.2859 23.2159 13.1151C25.6895 14.9443 27.2839 17.5228 27.2839 20.4289C27.2839 23.3349 25.6895 25.9135 23.2159 27.7426C20.7421 29.5719 17.3551 30.6839 13.6419 30.6839C9.92883 30.6839 6.54183 29.5719 4.06801 27.7426C1.59435 25.9135 0 23.3349 0 20.4289C0 17.5228 1.59435 14.9443 4.06801 13.1151Z",
    fill: "url(#paint0_linear_5580_23067)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7317 10.0493C22.5088 9.85204 22.2087 9.74915 21.9 9.74057H20.7167V5.39333C20.7167 3.63557 19.7564 2.18648 18.4016 1.29474C17.0469 0.402999 15.332 0 13.6428 0C11.9537 0 10.2388 0.402999 8.88401 1.29474C7.52925 2.18648 6.56891 3.63557 6.56891 5.39333V9.74915H5.38564C5.07696 9.74915 4.77685 9.86061 4.55392 10.0578C4.33098 10.255 4.21094 10.5123 4.21094 10.7867V21.1617C4.21094 21.4361 4.33955 21.7019 4.55392 21.8906C4.77685 22.0878 5.07696 22.1907 5.38564 22.1907H21.9C22.2087 22.1907 22.5088 22.0792 22.7317 21.8906C22.9547 21.6934 23.0747 21.4361 23.0747 21.1617V10.7867C23.0747 10.5123 22.9547 10.2465 22.7317 10.0578V10.0493ZM8.92688 5.39333C8.92688 4.25293 9.44135 3.51552 10.2988 2.95818C11.1562 2.40085 12.391 2.07502 13.6514 2.07502C14.9118 2.07502 16.1466 2.40085 16.9954 2.95818C17.8443 3.51552 18.3674 4.25293 18.3674 5.39333V9.74915H8.92688V5.39333Z",
    fill: "url(#paint1_linear_5580_23067)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5580_23067",
    x1: 22.1826,
    y1: 11.8892,
    x2: 5.10227,
    y2: 28.9695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5580_23067",
    x1: 23.6063,
    y1: 40.0169,
    x2: 12.228,
    y2: 12.3215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFFC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e603212b3a8c393b412e511a0798b3cc.svg";
export { ForwardRef as ReactComponent };